import { getDefaultState } from './state';

export default {  
  SET_ALL_RATES(state, {rates, total, per_page}) {
    state.rates = rates;
    state.totalPage = total / per_page;
    state.totalItems = total;
  },

  SET_RATE(state, rate) {
    state.rate = rate;
  },

  EDIT_RATE(state, rate){
    state.rates = state.rates.map(item => {
      if(item.rate_uuid === rate.rate_uuid) {
        return rate;
      } 

      return item;
    });
  },
  
  REMOVE__RATE(state, rate_uuid) {
    state.rates = state.rates.filter(rate => rate.rate_uuid !== rate_uuid);
  },

  UPDATE_RATES(state, rates) {
    state.rates = rates;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  }
};
